(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Contador: sobe de 0 até o valor quando o número entra na tela.
  function initCounters(root) {
    var els = root.querySelectorAll('[data-count]');
    if (!els.length) return;
    els.forEach(function (el) {
      if (el.__hoadCount) return;
      el.__hoadCount = true;
      var alvo = parseInt(el.getAttribute('data-count'), 10);
      if (isNaN(alvo) || reduce || !('IntersectionObserver' in window)) return;
      var digitos = el.getAttribute('data-count').length;
      el.textContent = new Array(digitos + 1).join('0');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(el);
            var inicio = null;
            function passo(ts) {
              if (!inicio) inicio = ts;
              var p = Math.min((ts - inicio) / 1000, 1);
              var suave = 1 - Math.pow(1 - p, 3);
              el.textContent = String(Math.round(suave * alvo)).padStart(digitos, '0');
              if (p < 1) requestAnimationFrame(passo);
            }
            requestAnimationFrame(passo);
          });
        },
        { threshold: 0.4 }
      );
      io.observe(el);
    });
  }

  // Brand story: fade-in quando entra na tela (sem JS já nasce visível).
  function initStory(root) {
    root.querySelectorAll('[data-hoad-story]').forEach(function (el) {
      if (el.__hoadStory) return;
      el.__hoadStory = true;
      if (reduce || !('IntersectionObserver' in window)) {
        el.classList.add('is-visible');
        return;
      }
      el.classList.add('hoad-story--anim');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              el.classList.add('is-visible');
              io.unobserve(el);
            }
          });
        },
        { threshold: 0.3 }
      );
      io.observe(el);
    });
  }

  // Banner dividido no celular: 2 slides (texto / foto), automático + arrasto.
  function initSplit(root) {
    root.querySelectorAll('[data-hoad-sb]').forEach(function (el) {
      if (el.__hoadSb) return;
      el.__hoadSb = true;
      var track = el.querySelector('[data-sb-track]');
      var dots = el.querySelectorAll('[data-sb-dot]');
      var mobile = el.querySelector('.hoad-sb__mobile');
      if (!track || !mobile) return;
      var current = 0;
      var total = 2;
      var paused = false;
      var startX = 0;

      function go(i) {
        current = (i + total) % total;
        track.style.transform = 'translateX(' + (current === 0 ? '0%' : '-50%') + ')';
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === current);
        });
      }

      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          go(k);
        });
      });

      mobile.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          paused = true;
        },
        { passive: true }
      );
      mobile.addEventListener(
        'touchend',
        function (e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) go(diff > 0 ? current + 1 : current - 1);
          setTimeout(function () {
            paused = false;
          }, 8000);
        },
        { passive: true }
      );

      if (!reduce) {
        setInterval(function () {
          if (!paused) go(current + 1);
        }, 5000);
      }
    });
  }

  function boot(root) {
    initCounters(root);
    initStory(root);
    initSplit(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
